export enum BookingCalendarStatus {
	HOLDING = "HOLDING",
	PENDING = "PENDING",
	REJECTED = "REJECTED",
	APPROVED = "APPROVED",
	CANCELED = "CANCELED",
}
